import { useDocumentLang, useTranslation } from '@web_opxp/features';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import CookieBannerWrapper from '../components/CookieBannerWrapper';
import FooterWrapper from '../components/footerWrapper/FooterWrapper';
import HeaderWrapperConnected from './components/HeaderWrapperConnected';
import Manage from './Manage';
import { ManageActions } from './slice';

export default function ManageApp() {
  const { language } = useTranslation();
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(ManageActions.startManageApp());
  }, [dispatch]);

  useDocumentLang();

  return (
    <div className="App" data-testid="manage-app">
      <HeaderWrapperConnected />
      <div className="App-body">
        <Manage />
      </div>
      <FooterWrapper />
      <CookieBannerWrapper language={language} />
    </div>
  );
}
